import { initialStateInfoFiscal } from "../initialStates/infoFiscal";

export const cloneTaxData = (value) => {
  if (typeof value === "string") {
    return JSON.parse(value);
  }

  return JSON.parse(JSON.stringify(value));
};

export const createManualTax = () => {
  const impostoManual = cloneTaxData(initialStateInfoFiscal.imposto_manual);
  impostoManual.icms.informar_credito_presumido = false;
  impostoManual.issqn.informar_issqn = false;
  return impostoManual;
};

export const completeManualTaxDefaults = (value) => {
  const defaults = createManualTax();
  if (!value) return defaults;

  const fillMissing = (template, current) => {
    if (template === null || typeof template !== "object") {
      if (current === undefined) return template;
      if ((current === null || current === "") && template !== null) return template;
      return current;
    }

    if (!current || typeof current !== "object" || Array.isArray(current)) {
      return cloneTaxData(template);
    }

    const result = { ...current };
    Object.keys(template).forEach((key) => {
      result[key] = fillMissing(template[key], current[key]);
    });
    return result;
  };

  return fillMissing(defaults, cloneTaxData(value));
};

export const applyItemTaxFromRef = (item, ref, refs) => {
  const selectedRef = (refs || []).find((tax) => tax.ref === ref);

  if (ref && !selectedRef) return false;

  const impostoManual = selectedRef?.flags?.isManual
    ? completeManualTaxDefaults(selectedRef.imposto_manual)
    : createManualTax();
  impostoManual.icms.informar_credito_presumido = Boolean(
    selectedRef?.flags?.enableCreditoPresumido
  );
  impostoManual.issqn.informar_issqn = Boolean(
    selectedRef?.flags?.enableIssqn
  );

  item.imposto_manual = impostoManual;
  item.usar_imposto_manual = Boolean(selectedRef?.flags?.isManual);
  return true;
};

export const ensureItemTax = (item, refs) => {
  if (item.imposto_manual) {
    item.imposto_manual = completeManualTaxDefaults(item.imposto_manual);
    item.usar_imposto_manual = Boolean(item.usar_imposto_manual);
    return item;
  }

  item.usar_imposto_manual = Boolean(item.usar_imposto_manual);
  applyItemTaxFromRef(item, item.classe_imposto, refs);
  return item;
};
